var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "24px",
    viewBox: "0 0 22 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Base / Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.1133333,19.9128395 C13.1888943,20.9956433 14.4844369,21.537037 16,21.537037 C17.5155631,21.537037 18.8111057,20.9956433 19.8866667,19.9128395 C20.9622276,18.8300357 21.5,17.5257689 21.5,16 C21.5,14.4742311 20.9622276,13.1699643 19.8866667,12.0871605 C18.8111057,11.0043567 17.5155631,10.462963 16,10.462963 C14.4844369,10.462963 13.1888943,11.0043567 12.1133333,12.0871605 C11.0377724,13.1699643 10.5,14.4742311 10.5,16 C10.5,17.5257689 11.0377724,18.8300357 12.1133333,19.9128395 Z M24.4052858,17.1338028 L26.7841402,19.0234742 C27.0308375,19.2034438 27.0660794,19.4553974 26.8898671,19.7793427 L24.6167395,23.7746479 C24.4757696,24.0266053 24.2466971,24.0985921 23.9295149,23.9906103 L21.127753,22.8568075 C20.3876612,23.3967163 19.7533064,23.7746468 19.2246694,23.9906103 L18.8017619,27.0140845 C18.731277,27.3380298 18.5550673,27.5 18.2731276,27.5 L13.7268724,27.5 C13.4449327,27.5 13.268723,27.3380298 13.1982381,27.0140845 L12.7753306,23.9906103 C12.1057238,23.702659 11.4713689,23.3247285 10.872247,22.8568075 L8.07048512,23.9906103 C7.75330294,24.0985921 7.52423036,24.0266053 7.3832605,23.7746479 L5.1101329,19.7793427 C4.93392058,19.4553974 4.96916251,19.2034438 5.21585977,19.0234742 L7.59471423,17.1338028 C7.55947176,16.8818454 7.5418508,16.5039149 7.5418508,16 C7.5418508,15.4960851 7.55947176,15.1181546 7.59471423,14.8661972 L5.21585977,12.9765258 C4.96916251,12.7965562 4.93392058,12.5446026 5.1101329,12.2206573 L7.3832605,8.22535211 C7.52423036,7.97339467 7.75330294,7.90140791 8.07048512,8.00938967 L10.872247,9.14319249 C11.6123388,8.60328369 12.2466936,8.22535319 12.7753306,8.00938967 L13.1982381,4.98591549 C13.268723,4.66197021 13.4449327,4.5 13.7268724,4.5 L18.2731276,4.5 C18.5550673,4.5 18.731277,4.66197021 18.8017619,4.98591549 L19.2246694,8.00938967 C19.8942762,8.29734103 20.5286311,8.67527153 21.127753,9.14319249 L23.9295149,8.00938967 C24.2466971,7.90140791 24.4757696,7.97339467 24.6167395,8.22535211 L26.8898671,12.2206573 C27.0660794,12.5446026 27.0308375,12.7965562 26.7841402,12.9765258 L24.4052858,14.8661972 C24.4405282,15.1181546 24.4581492,15.4960851 24.4581492,16 C24.4581492,16.5039149 24.4405282,16.8818454 24.4052858,17.1338028 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expermentation-v02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.0-additional-details",
    transform: "translate(-32.000000, -352.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(16.000000, 328.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-Color",
    fill: "#000000",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.99960ed744ddfacfebb16d38381e786b.svg";
export { ForwardRef as ReactComponent };